export { authMixin } from './auth';
export { parserMixin } from './parser';


// WEBPACK FOOTER //
// ./src/mixins/index.js